import { configureStore } from '@reduxjs/toolkit';
import ServiceReducer from "./Slice/serviceslice";
import PlanReducer from "./Slice/planslice";
import AuthSlice from "./Slice/AuthSlice";
import MessageReducer from "./Slice/message";
import ForgotReducer from "./Slice/forgotSlice"
import  resetPasswordReducer  from './Slice/resetPasswordSlice';
import loaderReducer from "./Slice/loaderSlice";
import InspirationReducer from "./Slice/inspirationSlice";
import roleReducer from "./Slice/roleSlice";
import ImageReducer from "./Slice/imageSlice";
import EmployeeReducer from "./Slice/employeeSlice";
import TemplateReducer from "./Slice/showcase/templateSlice";
import TagReducer from "./Slice/showcase/tagSlice";
import LeadReducer from "./Slice/LeadSlice";
import assignLeadSliceReducer from "./Slice/assignLeadSlice";
import CustomerReducer from "./Slice/customerSlice";
import ProductTemplateReducer from "./Slice/ProductTemplate"
import InspirationtemplateSlice from "./Slice/InspirationTemplate"
import b2bLeadReducer from "./Slice/b2bLeadSlice";
import quoteReducer from "./Slice/quoteSlice";
import updateCustomerSubscription  from './Slice/cusSubcription';
import productReducer from "./Slice/Product";
import emailReducer from "./Slice/emailTemplate"



const reducer={
  service:ServiceReducer,
  plan:PlanReducer,
  auth:AuthSlice,
  message:MessageReducer,
  forgot:ForgotReducer,
  reset:resetPasswordReducer,
  loading:loaderReducer,
  inspiration:InspirationReducer,
  image:ImageReducer,
  roles:roleReducer,
  employee:EmployeeReducer,
  tag:TagReducer,
  template:TemplateReducer,
  leads:LeadReducer,
  assignLeads:assignLeadSliceReducer,
  customer: CustomerReducer,
  product: productReducer,
  productTemplate: ProductTemplateReducer,
  inspirationTemplate: InspirationtemplateSlice,
  b2bLead:b2bLeadReducer,
  quote:quoteReducer,
  subcription:updateCustomerSubscription,
  email:emailReducer,
}

const store =configureStore({
  reducer:reducer,
  devTools:true,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  })
})



export default store;